import React, { useMemo } from 'react';
import { Select } from 'antd';
import dayjs from 'dayjs';

const { Option } = Select;

/**
 * 🧠 Global Date Presets for Quick Filtering
 */
export const getDatePresets = () => [
    { label: 'Today', range: [dayjs().startOf('day'), dayjs().endOf('day')], value: 'today' },
    { label: 'Yesterday', range: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')], value: 'yesterday' },
    { label: 'This Week', range: [dayjs().startOf('week'), dayjs().endOf('day')], value: 'thisWeek' },
    { label: 'This Month', range: [dayjs().startOf('month'), dayjs().endOf('day')], value: 'thisMonth' },
    { label: 'Last 7 Days', range: [dayjs().subtract(6, 'day').startOf('day'), dayjs().endOf('day')], value: 'last7' },
    { label: 'Last 30 Days', range: [dayjs().subtract(29, 'day').startOf('day'), dayjs().endOf('day')], value: 'last30' },
];

/**
 * 🚀 QuickFilter Component
 * A standardized dropdown for selecting common date ranges.
 * 
 * @param {string} value - Current quick filter key (e.g., 'today')
 * @param {function} onChange - Callback receiving (selectedKey, dateRangeArray)
 * @param {string} placeholder - Input placeholder
 */
const QuickFilter = ({ value, onChange, placeholder = "Select Preset", label = "Quick Filter" }) => {
    const presets = useMemo(() => getDatePresets(), []);

    const handleChange = (val) => {
        if (!val) {
            onChange(undefined, null);
            return;
        }
        const preset = presets.find(p => p.value === val);
        onChange(val, preset ? preset.range : null);
    };

    return (
        <div className="product-setup-filter-item">
            {label && (
                <div 
                    className="pcu-font-11 pcu-font-700 pcu-margin-bottom-6 pcu-color-title pcu-opacity-50 pcu-letter-spacing-1 pcu-uppercase" 
                    style={{ fontFamily: 'var(--font-family-primary)' }}
                >
                    {label}
                </div>
            )}
            <Select
                placeholder={placeholder}
                style={{ width: '100%', height: '34px' }}
                value={value}
                onChange={handleChange}
                allowClear
            >
                {presets.map(preset => (
                    <Option key={preset.value} value={preset.value}>{preset.label}</Option>
                ))}
            </Select>
        </div>
    );
};

export default QuickFilter;
